module.exports = __webpack_public_path__ + "media/images/athletes/1704-7b8ee62ade42c2042e89f6af9eceb696.png";